<template>
  <div class="detail">
    <el-card shadow="never" class="box-card">
      <div class="affitem">
        <el-row>
          <el-col :span="7">
            <div class="headsrc">
              <el-avatar :size="90" :src="dataInfo.headSrc"></el-avatar>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="name">{{ dataInfo.name }}</div>
            <div class="subdesc">{{ dataInfo.countryName }}</div>
          </el-col>
          <el-col :span="7">
            <div class="score">Quality Score</div>
            <div class="scoreval">
              {{ dataInfo.qualityScore }}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="operatebox">
              <img
                v-if="dataInfo.isConcern == 1"
                src="@/assets/img/home/love.png"
                alt=""
                @click="delConcern(dataInfo)"
              />
              <img
                v-else
                src="@/assets/img/home/love2.png"
                alt=""
                @click="addConcern(dataInfo)"
              />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="operatebox2">
              <img
                v-if="dataInfo.hasEmail == 1"
                src="@/assets/img/home/eml.png"
                alt=""
                @click="sendEmail(dataInfo)"
              />
              <img
                v-else
                src="@/assets/img/home/eml1.png"
                alt=""
                @click="noEmail"
              />
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card shadow="never" class="box-card">
      <el-tabs v-model="activeName" :stretch="true" @tab-click="detailclick">
        <el-tab-pane
          v-for="item in tabDataList"
          :key="item.prompType"
          :label="item.prompType"
          :name="item.prompType"
        >
          <div class="typemain">
            <div class="register" v-if="item.data.registeTime">
              注册时间： {{ item.data.registeTime }}
            </div>
            <div class="desc" v-if="item.data.introduce">
              <div class="title">简介：</div>
              <div>{{ item.data.introduce }}</div>
            </div>

            <div class="toji">
              <el-card
                class="box-card"
                shadow="never"
                v-for="(item, index) in item.data.formField"
                :key="index"
              >
                <div class="itembox">
                  <el-row>
                    <el-col :span="12">
                      <div class="headsrc" :class="bgclass(item.labelName)">
                        <img class="img1" :src="iconImg(item.labelName)" />
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="name">{{ item.labelName }}</div>
                      <div class="subdesc">{{ item.value }}</div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
              <div v-if="activeName=='YouTube'" class="tips">请用电脑查看Youtube近期带货视频</div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="'渠道详情' + (mealType !== 'FREE_DAY' ? '(Coming Soon)' : '')"
          name="2"
        >
          <div class="detailbox">
            <el-card
              v-if="chartnum1 > 0"
              class="box-card"
              style="margin-bottom: 8px"
            >
              <div class="title">区域影响力</div>
              <div class="charts">
                <div id="myChart1"></div>
                <!-- <div v-if="mealType !== 'FREE_DAY'" class="mohubox"></div> -->
              </div>
            </el-card>
            <el-card
              v-if="chartnum2 > 0"
              class="box-card"
              style="margin-bottom: 8px"
            >
              <div class="title">联盟平台</div>
              <div class="charts">
                <div id="myChart2"></div>
                <!-- <div v-if="mealType !== 'FREE_DAY'" class="mohubox"></div> -->
              </div>
            </el-card>
            <el-card
              v-if="chartnum3 > 0"
              class="box-card"
              style="margin-bottom: 8px"
            >
              <div class="title">合作品牌</div>
              <div class="charts">
                <div id="myChart3"></div>
                <!-- <div v-if="mealType !== 'FREE_DAY'" class="mohubox"></div> -->
              </div>
            </el-card>
            <el-card
              v-if="chartnum4 > 0"
              class="box-card"
              style="margin-bottom: 8px"
            >
              <div class="title">带货行业</div>
              <div class="charts">
                <div id="myChart4"></div>
                <!-- <div v-if="mealType !== 'FREE_DAY'" class="mohubox"></div> -->
              </div>
            </el-card>
            <el-card
              v-if="focusTopicNum > 0"
              class="box-card"
              style="margin-bottom: 8px"
            >
              <div class="title">焦点话题</div>
              <div class="charts">
                <div id="myChart5"></div>
                <!-- <div v-if="mealType !== 'FREE_DAY'" class="mohubox"></div> -->
              </div>
            </el-card>
            <el-card
              v-if="contentTypeNum > 0"
              class="box-card"
              style="margin-bottom: 8px"
            >
              <div class="title">内容类型</div>
              <div class="charts">
                <div id="myChart6"></div>
                <!-- <div v-if="mealType !== 'FREE_DAY'" class="mohubox"></div> -->
              </div>
            </el-card>
            <el-card
              v-if="contentStyleNum > 0"
              class="box-card"
              style="margin-bottom: 8px"
            >
              <div class="title">内容风格</div>
              <div class="charts">
                <div id="myChart7"></div>
                <!-- <div v-if="mealType !== 'FREE_DAY'" class="mohubox"></div> -->
              </div>
            </el-card>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import {
  ALLIANCEDETAILPART1,
  ALLIANCEDETAILPART2,
  REMOVEGROUPONEDETAIL,
} from "@/api/foll";
import { RECORDS } from "@/api/personal";
import {
  QUERYDETAILCHARTS,
  JOINGROUP,
  QUERYDETAILClOUDWORD,
} from "@/api/cutting";
import "echarts-wordcloud";
export default {
  data() {
    return {
      allianceCode: this.$route.query.code,
      dataInfo: {},
      tabDataList: [],
      activeName: null,
      mealType: null,

      brandtable: [{}, {}, {}, {}, {}],
      brandChart: [],
      countryChart: [{}, {}, {}, {}],
      industryChart: [{}, {}, {}, {}],
      dhhyXData: [],
      dhhyData: [],
      youtubeVideos: [],
      focusTopic: [],
      contentStyle: [],
      contentType: [],
      customColors: ["#f56c6c", "#e6a23c", "#5cb87a", "#1989fa", "#6f7ad3"],
      colorBox: [
        "#bd2760",
        "rgb(176, 70, 109)",
        "rgb(209, 132, 160)",
        "rgb(235, 181, 200)",
        "rgb(247, 215, 226)",
      ],
      focusTopicNum: 0,
      contentTypeNum: 0,
      contentStyleNum: 0,
      chartnum1: 0,
      chartnum2: 0,
      chartnum3: 0,
      chartnum4: 0,
    };
  },
  computed: {},
  created() {
    this.decords();
    this.getData();
  },
  mounted() {
    this.getTabsData();
    this.queryDetailCharts();
  },
  methods: {
    iconImg(val) {
      const ba1 = ["订阅数", "粉丝数", "跳出率", "预估成交"];
      const ba2 = ["总观看数", "月访问量"];
      const ba3 = ["总视频数", "带货内容平均互动率"];
      const ba4 = ["近1年带货视频数"];
      const ba5 = ["带货视频平均观看次数", "带货内容平均互动率"];
      const ba6 = ["带货内容平均评论数", "带货视频平均评论数"];
      const ba7 = ["总帖子数", "平均访问页数"];
      const ba8 = ["近一年带货内容数", "近1年带货内容数"];
      const ba9 = ["总获赞数"];
      const ba10 = ["进驻渠道"];
      const ba11 = ["进驻商家"];
      const ba12 = ["Karma分"];

      if (ba1.includes(val)) {
        return require("@/assets/img/detils/002.png");
      } else if (ba2.includes(val)) {
        return require("@/assets/img/detils/003.png");
      } else if (ba3.includes(val)) {
        return require("@/assets/img/detils/004.png");
      } else if (ba4.includes(val)) {
        return require("@/assets/img/detils/005.png");
      } else if (ba5.includes(val)) {
        return require("@/assets/img/detils/006.png");
      } else if (ba6.includes(val)) {
        return require("@/assets/img/detils/007.png");
      } else if (ba7.includes(val)) {
        return require("@/assets/img/detils/009.png");
      } else if (ba8.includes(val)) {
        return require("@/assets/img/detils/010.png");
      } else if (ba9.includes(val)) {
        return require("@/assets/img/detils/011.png");
      } else if (ba10.includes(val)) {
        return require("@/assets/img/detils/012.png");
      } else if (ba11.includes(val)) {
        return require("@/assets/img/detils/013.png");
      } else if (ba12.includes(val)) {
        return require("@/assets/img/detils/014.png");
      }
    },
    bgclass(val) {
      const ba1 = ["订阅数", "粉丝数", "跳出率", "预估成交"];
      const ba2 = [
        "总观看数",
        "总帖子数",
        "平均访问页数",
        "总获赞数",
        "点赞数",
        "进驻商家",
        "月访问量",
        "Karma分",
      ];
      const ba3 = [
        "总视频数",
        "带货内容平均互动率",
        "总视频数",
        "带货内容平均互动率",
      ];
      const ba4 = [
        "近1年带货视频数",
        "近1年带货内容数",
        "近一年带货内容数",
        "总视频数",
      ];
      const ba5 = [
        "带货视频平均观看次数",
        "带货内容平均互动率",
        "进驻渠道",
        "月访问量",
      ];
      const ba6 = ["带货内容平均评论数", "带货视频平均评论数"];
      if (ba1.includes(val)) {
        return "ba1";
      } else if (ba2.includes(val)) {
        return "ba2";
      } else if (ba3.includes(val)) {
        return "ba3";
      } else if (ba4.includes(val)) {
        return "ba4";
      } else if (ba5.includes(val)) {
        return "ba5";
      } else if (ba6.includes(val)) {
        return "ba6";
      } else {
        return "ba2";
      }
    },
    // 获取是否是免费用户
    decords() {
      RECORDS({}).then((res) => {
        this.mealType = res.data.body.mealType;
      });
    },
    getData() {
      ALLIANCEDETAILPART1({ allianceCode: this.allianceCode }).then((res) => {
        this.dataInfo = res.data.body;
      });
    },
    getTabsData() {
      ALLIANCEDETAILPART2({
        allianceCode: this.allianceCode,
      }).then((res) => {
        if (res.data.body) {
          if (res.data.body && res.data.body.length < 1) {
            this.detailclick();
          } else {
            this.tabDataList = res.data.body;
            this.activeName = res.data.body[0].prompType;
          }
        }
      });
    },
    detailclick(e) {
      this.activeName = "2";
      this.$nextTick(() => {
        this.getWorld();
      });
    },
    // 移除关注分组
    delConcern(e) {
      REMOVEGROUPONEDETAIL({
        groupCode: "concern001",
        allianceCode: e.allianceCode,
      }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "已取消关注",
            type: "success",
          });
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 加入到关注分组
    addConcern(e) {
      let userGroups = [
        {
          groupCode: "concern001",
          allianceCode: e.allianceCode,
        },
      ];
      JOINGROUP({ userGroups }).then((res) => {
        if (res.data.code == "success") {
          this.$message({
            message: "已关注",
            type: "success",
          });
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    queryDetailCharts() {
      QUERYDETAILCHARTS({ allianceCode: this.allianceCode }).then((res) => {
        this.brandChart = res.data.body.brand;
        let tempValue = res.data.body.brand.value;
        let temp = [];
        res.data.body.brand.name.forEach((item, index) => {
          temp.push({
            name: item,
            value: tempValue[index],
          });
        });
        let dhhyXDataTemp = [];
        let dhhyDataTemp = [];
        if (this.mealType !== "FREE_DAY") {
          // 暂时显示数据
          this.countryChart = [
            { name: "US", value: 100, itemStyle: { color: "#bd2760" } },
            {
              name: "UK",
              value: 100,
              itemStyle: { color: "rgb(176, 70, 109)" },
            },
            {
              name: "UN",
              value: 100,
              itemStyle: { color: "rgb(209, 132, 160)" },
            },
            {
              name: "CHINA",
              value: 100,
              itemStyle: { color: "rgb(235, 181, 200)" },
            },
            {
              name: "UE",
              value: 100,
              itemStyle: { color: "rgb(247, 215, 226)" },
            },
          ];
          this.industryChart = [
            { name: "消费电子", value: 100, itemStyle: { color: "#bd2760" } },
            {
              name: "户外运动",
              value: 100,
              itemStyle: { color: "rgb(176, 70, 109)" },
            },
            {
              name: "美妆",
              value: 100,
              itemStyle: { color: "rgb(209, 132, 160)" },
            },
            {
              name: "家居",
              value: 100,
              itemStyle: { color: "rgb(235, 181, 200)" },
            },
            {
              name: "穿戴饰品",
              value: 100,
              itemStyle: { color: "rgb(247, 215, 226)" },
            },
          ];
          this.dhhyXData = ["pepperjam", "CJ Affiliate", "Amazon", "Impact"];
          this.dhhyData = [1052, 1201, 1685, 536];
          this.brandChart = {
            name: ["pepperjam", "CJ Affiliate", "Amazon", "Impact"],
            value: [2610, 1415, 593, 892],
          };
        } else {
          this.brandtable = temp;
          this.countryChart = res.data.body.country;
          this.industryChart = res.data.body.industry;
          this.countryChart.forEach((item, index) => {
            item.itemStyle = {
              color: this.colorBox[index]
                ? this.colorBox[index]
                : "rgb(209, 132, 160)",
            };
          });
          this.industryChart.forEach((item, index) => {
            dhhyXDataTemp.push(item.name);
            dhhyDataTemp.push(item.value);
            item.itemStyle = {
              color: this.colorBox[index]
                ? this.colorBox[index]
                : "rgb(209, 132, 160)",
            };
          });
          this.dhhyXData = res.data.body.affilate.name;
          this.dhhyData = res.data.body.affilate.value;
        }
        if (this.countryChart) {
          this.chartnum1 = this.countryChart.length;
        } else {
          this.chartnum1 = 0;
        }
        if (this.dhhyData) {
          this.chartnum2 = this.dhhyData.length;
        } else {
          this.chartnum2 = 0;
        }
        if (this.brandChart.value) {
          this.chartnum3 = this.brandChart.value.length;
        } else {
          this.chartnum3 = 0;
        }
        if (this.industryChart) {
          this.chartnum4 = this.industryChart.length;
        } else {
          this.chartnum4 = 0;
        }
        this.getWorld();
      });
    },
    getWorld() {
      if (this.chartnum1 > 0) {
        this.drawChart1();
      }
      if (this.chartnum2 > 0) {
        this.drawChart2();
      }
      if (this.chartnum3 > 0) {
        this.drawChart3();
      }
      if (this.chartnum4 > 0) {
        this.drawChart4();
      }
      QUERYDETAILClOUDWORD({ allianceCode: this.allianceCode }).then((res) => {
        if (this.mealType !== "FREE_DAY") {
          this.contentType = [
            { name: "类型A", value: 42, itemStyle: { color: "#bd2760" } },
            {
              name: "类型B",
              value: 65,
              itemStyle: { color: "rgb(176, 70, 109)" },
            },
            {
              name: "类型C",
              value: 78,
              itemStyle: { color: "rgb(209, 132, 160)" },
            },
            {
              name: "类型D",
              value: 53,
              itemStyle: { color: "rgb(235, 181, 200)" },
            },
            {
              name: "类型E",
              value: 99,
              itemStyle: { color: "rgb(247, 215, 226)" },
            },
          ];
          this.focusTopic = [
            { name: "focusTopicA", value: 60 },
            { name: "focusTopicB", value: 50 },
            { name: "focusTopicC", value: 40 },
            { name: "focusTopicD", value: 30 },
            { name: "focusTopicE", value: 20 },
            { name: "focusTopicF", value: 10 },
          ];
          this.contentStyle = [
            { name: "contentStyleA", value: 60 },
            { name: "contentStyleB", value: 50 },
            { name: "contentStyleC", value: 40 },
            { name: "contentStyleD", value: 30 },
            { name: "contentStyleE", value: 20 },
            { name: "contentStyleF", value: 10 },
          ];
        } else {
          let focusTopic = res.data.body.focusTopic
            ? res.data.body.focusTopic
            : [];
          let contentStyle = res.data.body.contentStyle
            ? res.data.body.contentStyle
            : [];
          this.contentType = res.data.body.contentType;
          this.focusTopic = [];
          this.contentStyle = [];
          if (focusTopic) {
            focusTopic.forEach((item, index) => {
              this.focusTopic.push({
                name: item[0],
                value: item[1],
              });
            });
          }
          if (contentStyle) {
            contentStyle.forEach((item, index) => {
              this.contentStyle.push({
                name: item[0],
                value: item[1],
              });
            });
          }
          if (this.contentType) {
            this.contentType.forEach((item, index) => {
              if (index < 5) {
                item.itemStyle = {
                  color: this.colorBox[index] ? this.colorBox[index] : "",
                };
              }
            });
          }
        }
        if (this.contentType) {
          this.contentTypeNum = this.contentType.length;
        } else {
          this.contentTypeNum = 0;
        }
        if (this.contentStyle) {
          this.contentStyleNum = this.contentStyle.length;
        } else {
          this.contentStyleNum = 0;
        }
        if (this.focusTopic) {
          this.focusTopicNum = this.focusTopic.length;
        } else {
          this.focusTopicNum = 0;
        }

        if (this.contentTypeNum > 0) {
          this.$nextTick(() => {
            this.drawChart6();
          });
        }
        if (this.focusTopicNum > 0) {
          this.$nextTick(() => {
            this.drawChart5();
          });
        }
        if (this.contentStyleNum > 0) {
          this.$nextTick(() => {
            this.drawChart7();
          });
        }
      });
    },
    drawChart1() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("myChart1"));
      // 绘制图表
      chart.setOption({
        tooltip: {
          trigger: "item",
        },
        // label: {
        //     formatter: '{b|{b}：{c}}{abg|}\n{hr|}\n   {a|{d}%}   ',
        //     backgroundColor: '#F6F8FC',
        //     borderColor: '#8C8D8E',
        //     borderWidth: 1,
        //     borderRadius: 4,
        //     rich: {
        //         a: {
        //             color: '#6E7079',
        //             lineHeight: 22,
        //             align: 'center',
        //             padding: 10
        //         },
        //         hr: {
        //             borderColor: '#8C8D8E',
        //             width: '100%',
        //             borderWidth: 1,
        //             height: 0,
        //         },
        //         b: {
        //             color: '#4C5058',
        //             fontSize: 14,
        //             fontWeight: 'bold',
        //             lineHeight: 25,
        //             padding: [0, 10]
        //         },
        //         per: {
        //             color: '#fff',
        //             backgroundColor: '#4C5058',
        //             padding: [3, 4],
        //             borderRadius: 4,
        //         }
        //     }
        // },
        series: [
          {
            name: "区域影响力",
            type: "pie",
            radius: ["40%", "55%"],
            data: this.countryChart,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    drawChart2() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("myChart2"));
      // 绘制图表
      chart.setOption({
        grid: {
          x: 50,
          y2: 60,
        },
        xAxis: {
          type: "category",
          data: this.dhhyXData,
          axisLabel: {
            // 旋转角度
            rotate: 15,
          },
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            data: this.dhhyData,
            type: "bar",
            barWidth: 15,
            showBackground: true,
            color: "rgba(190, 60, 110, 1)",
            backgroundStyle: {
              color: "rgba(252, 240, 244, 1)",
            },
          },
        ],
      });
    },
    drawChart3() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("myChart3"));
      // 绘制图表
      chart.setOption({
        grid: {
          x: 50,
          y2: 60,
        },
        xAxis: {
          type: "category",
          data: this.brandChart.name,
          axisLabel: {
            // 旋转角度
            rotate: 15,
          },
        },

        yAxis: {
          type: "value",
          minInterval: 1,
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            data: this.brandChart.value,
            type: "bar",
            barWidth: 15,
            showBackground: true,
            color: "rgba(190, 60, 110, 1)",
            backgroundStyle: {
              color: "rgba(252, 240, 244, 1)",
            },
          },
        ],
      });
    },
    drawChart4() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("myChart4"));
      // 绘制图表
      chart.setOption({
        tooltip: {
          trigger: "item",
        },
        // label: {
        //     formatter: '{b|{b}：{c}}{abg|}\n{hr|}\n   {a|{d}%}   ',
        //     backgroundColor: '#F6F8FC',
        //     borderColor: '#8C8D8E',
        //     borderWidth: 1,
        //     borderRadius: 4,
        //     rich: {
        //         a: {
        //             color: '#6E7079',
        //             lineHeight: 22,
        //             align: 'center',
        //             padding: 10
        //         },
        //         hr: {
        //             borderColor: '#8C8D8E',
        //             width: '100%',
        //             borderWidth: 1,
        //             height: 0,
        //         },
        //         b: {
        //             color: '#4C5058',
        //             fontSize: 14,
        //             fontWeight: 'bold',
        //             lineHeight: 25,
        //             padding: [0, 10]
        //         },
        //         per: {
        //             color: '#fff',
        //             backgroundColor: '#4C5058',
        //             padding: [3, 4],
        //             borderRadius: 4,
        //         }
        //     }
        // },
        series: [
          {
            name: "带货行业",
            type: "pie",
            radius: ["40%", "55%"],
            data: this.industryChart,

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    drawChart5() {
      const dom = document.getElementById("myChart5");
      let myChart = this.$echarts.init(dom);
      myChart.setOption({
        series: [
          {
            type: "wordCloud",
            data: this.focusTopic.slice(0, 10),
            // shape这个属性虽然可配置，但是在词的数量不太多的时候，效果不明显，它会趋向于画一个椭圆
            // shape: 'circle',
            // 词的大小，最小12px，最大60px，可以在这个范围调整词的大小
            sizeRange: [12, 28],
            // 每个词旋转的角度范围和旋转的步进
            rotationRange: [0, 0],
            // 词间距，数值越小，间距越小，这里间距太小的话，会出现大词把小词套住的情况，比如一个大的口字，中间会有比较大的空隙，这时候他会把一些很小的字放在口字里面，这样的话，鼠标就无法选中里面的那个小字，这里可以用函数根据词云的数量动态返回间距
            gridSize: 5,
            // 允许词太大的时候，超出画布的范围
            drawOutOfBound: true,
            // 布局的时候是否有动画
            layoutAnimation: true,
            // 这是全局的文字样式，相对应的还可以对每个词设置字体样式
            textStyle: {
              fontFamily: "Verdana, Arial, Helvetica, sans-serif",
              fontWeight: "bold",
              // 颜色可以用一个函数来返回字符串，这里是随机色
              color: function (e) {
                let wordcloudColor = [
                  "#86D4FF",
                  "#FF8F6C",
                  "#2CF263",
                  "#9FA8F7",
                  "#1274FF",
                  "#E6613D",
                  "#FFC629",
                  "#FFAB2E",
                  "#F78289",
                  "#FF6C96",
                  "#45BFD4",
                  "#4E31FF",
                  "#31FBFB",
                  "#86D4FF",
                  "#BF8AFD",
                  "#FFF500",
                  "#DE58FF",
                  "#72ED7C",
                  "#0BEEB8",
                  "#931CFF",
                  "#3D25F2",
                  "#F995C8",
                  "#FBE9B4",
                  "#FF4AB6",
                ];
                return wordcloudColor[Math.round(Math.random() * 24)];
                // Random color
                // return 'rgb(' + [
                //   Math.round(Math.random() * 160),
                //   Math.round(Math.random() * 160),
                //   Math.round(Math.random() * 160)
                // ].join(',') + ')';
              },
            },
            emphasis: {
              focus: "self",
              textStyle: {
                textShadowBlur: 10,
                textShadowColor: "#ccc",
              },
            },
          },
        ],
      });
    },
    drawChart6() {
      // 基于准备好的dom，初始化echarts实例
      let chart = this.$echarts.init(document.getElementById("myChart6"));
      // 绘制图表
      chart.setOption({
        tooltip: {
          trigger: "item",
        },
        // label: {
        //     formatter: '{b|{b}：{c}}{abg|}\n{hr|}\n   {a|{d}%}   ',
        //     backgroundColor: '#F6F8FC',
        //     borderColor: '#8C8D8E',
        //     borderWidth: 1,
        //     borderRadius: 4,
        //     rich: {
        //         a: {
        //             color: '#6E7079',
        //             lineHeight: 22,
        //             align: 'center',
        //             padding: 10
        //         },
        //         hr: {
        //             borderColor: '#8C8D8E',
        //             width: '100%',
        //             borderWidth: 1,
        //             height: 0,
        //         },
        //         b: {
        //             color: '#4C5058',
        //             fontSize: 14,
        //             fontWeight: 'bold',
        //             lineHeight: 25,
        //             padding: [0, 10]
        //         },
        //         per: {
        //             color: '#fff',
        //             backgroundColor: '#4C5058',
        //             padding: [3, 4],
        //             borderRadius: 4,
        //         }
        //     }
        // },
        series: [
          {
            name: "内容类型",
            type: "pie",
            radius: ["40%", "55%"],
            data: this.contentType,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
    drawChart7() {
      const dom = document.getElementById("myChart7");
      let myChart = this.$echarts.init(dom);
      myChart.setOption({
        series: [
          {
            type: "wordCloud",
            data: this.contentStyle.slice(0, 7),
            // shape这个属性虽然可配置，但是在词的数量不太多的时候，效果不明显，它会趋向于画一个椭圆
            shape: "circle",
            // 词的大小，最小12px，最大60px，可以在这个范围调整词的大小
            sizeRange: [15, 35],
            // 每个词旋转的角度范围和旋转的步进
            rotationRange: [0, 0],
            // 词间距，数值越小，间距越小，这里间距太小的话，会出现大词把小词套住的情况，比如一个大的口字，中间会有比较大的空隙，这时候他会把一些很小的字放在口字里面，这样的话，鼠标就无法选中里面的那个小字，这里可以用函数根据词云的数量动态返回间距
            gridSize: 8,
            // 允许词太大的时候，超出画布的范围
            drawOutOfBound: true,
            // 布局的时候是否有动画
            layoutAnimation: true,
            // 这是全局的文字样式，相对应的还可以对每个词设置字体样式
            textStyle: {
              fontFamily: "sans-serif",
              fontWeight: "bold",
              // 颜色可以用一个函数来返回字符串，这里是随机色
              color: function () {
                let wordcloudColor = [
                  "#86D4FF",
                  "#FF8F6C",
                  "#2CF263",
                  "#9FA8F7",
                  "#1274FF",
                  "#E6613D",
                  "#FFC629",
                  "#FFAB2E",
                  "#F78289",
                  "#FF6C96",
                  "#45BFD4",
                  "#4E31FF",
                  "#31FBFB",
                  "#86D4FF",
                  "#BF8AFD",
                  "#FFF500",
                  "#DE58FF",
                  "#72ED7C",
                  "#0BEEB8",
                  "#931CFF",
                  "#3D25F2",
                  "#F995C8",
                  "#FBE9B4",
                  "#FF4AB6",
                ];
                return wordcloudColor[Math.round(Math.random() * 24)];
              },
            },
            emphasis: {
              focus: "self",
              textStyle: {
                textShadowBlur: 10,
                textShadowColor: "rgba(190, 60, 110, 1)",
              },
            },
          },
        ],
      });
    },
    noEmail() {
      this.$message({
        message: "暂无邮箱,更新中",
        type: "warning",
      });
    },
    //发送邮件
    sendEmail(info) {
      this.$router.push({
        path: "/sendEmail-m",
        query: { allianceCode: info.allianceCode, name: info.name },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  padding: 8px 8px 8px 8px;
  background-color: #fff;

  /deep/.el-card__body {
    padding: 8px !important;
  }

  .box-card {
    margin-bottom: 8px;

    .affitem {
      height: 90px;

      .headsrc {
        height: 90px;
        line-height: 90px;
      }

      .name {
        height: 45px;
        line-height: 45px;
        font-weight: 600;
        font-size: 13px;
      }

      .subdesc {
        height: 45px;
        line-height: 45px;
        font-size: 12px;
      }

      .score {
        height: 45px;
        line-height: 45px;
        font-weight: 600;
        font-size: 13px;
      }

      .scoreval {
        height: 45px;
        line-height: 45px;
        font-weight: 600;
        font-size: 18px;
        color: #be3c6e;
      }
    }

    .operatebox {
      text-align: center;
      padding: 10px;

      img {
        height: 40px;
      }
    }

    .operatebox2 {
      text-align: center;
      padding: 14px;

      img {
        height: 32px;
      }
    }

    .operateview {
      height: 50px;
      line-height: 50px;

      .operateview_item {
        text-align: center;

        img {
          height: 35px;
        }
      }

      .operateview_item3 {
        text-align: center;

        img {
          height: 30px;
        }
      }
    }

    .register {
      margin-bottom: 8px;
    }

    .desc {
      margin-bottom: 8px;
      display: flex;

      .title {
        width: 100%;
        display: flex;
      }
    }

    .toji {
      .itembox {
        .headsrc {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          text-align: center;

          img {
            width: 23px;
            transform: translateY(11px);
          }

          .img3 {
            transform: translateY(14px);
          }

          .img4 {
            transform: translateY(14px);
          }

          .img6 {
            transform: translateY(14px);
          }
        }

        .ba1 {
          background: rgba(74, 217, 145, 0.21);
        }

        .ba2 {
          background: rgba(130, 128, 255, 0.21);
        }

        .ba3 {
          background: rgba(254, 197, 61, 0.21);
        }

        .ba4 {
          background: rgba(195, 173, 155, 0.21);
        }

        .ba5 {
          background: rgba(86, 153, 221, 0.21);
        }

        .ba6 {
          background: rgba(255, 144, 102, 0.21);
        }

        .name {
          height: 23px;
          line-height: 23px;
          font-weight: 600;
          font-size: 12px;
          text-align: right;
        }

        .subdesc {
          height: 23px;
          line-height: 23px;
          font-size: 12px;
          text-align: right;
        }
      }

      .tips {
        text-align: center;
        color: #be3c6e;
      }
    }
  }

  .detailbox {
    .title {
      font-weight: 600;
    }

    #myChart1 {
      width: calc(100vw - 48px);
      height: 300px;
    }

    #myChart2 {
      width: calc(100vw - 48px);
      height: 300px;
    }

    #myChart3 {
      width: calc(100vw - 48px);
      height: 300px;
    }

    #myChart4 {
      width: calc(100vw - 48px);
      height: 300px;
    }

    #myChart5 {
      width: calc(100vw - 48px);
      height: 300px;
    }

    #myChart6 {
      width: calc(100vw - 48px);
      height: 300px;
    }

    #myChart7 {
      width: calc(100vw - 48px);
      height: 300px;
    }

    .charts {
      position: relative;

      .mohubox {
        position: absolute;
        bottom: 0px;
        width: 100%;
        height: 300px;
        background-color: #ffffff00;
        z-index: 999;
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
      }
    }
  }
}
</style>
